import { render, staticRenderFns } from "./SunTemplate.vue?vue&type=template&id=6233a146&scoped=true"
import script from "./SunTemplate.vue?vue&type=script&lang=js"
export * from "./SunTemplate.vue?vue&type=script&lang=js"
import style0 from "./SunTemplate.vue?vue&type=style&index=0&id=6233a146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233a146",
  null
  
)

export default component.exports